module.exports = __webpack_public_path__ + "34736292/img/dollar-icon.35c9d638.svg";